import { useEffect, useState } from "react";
import { Link, Navigate, Outlet } from "react-router-dom";
import { callEnsureCommunityMember, callRecordActiveMinute } from "../lib/firebase";
import { useAuth } from "../lib/auth";
import { brand, hasCommunity } from "../lib/brand";
import { levelForPoints } from "../lib/community";
import { DEFAULT_AVATAR, type Avatar } from "../lib/avatar";
import { PixelAvatar } from "./PixelAvatar";

// Wraps every community route: asks the server (once per page load) whether
// this account is a member (active enrollment), which also registers them.
export function CommunityGate() {
  const [member, setMember] = useState<boolean | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!hasCommunity(brand.id)) return;
    callEnsureCommunityMember()
      .then(setMember)
      .catch((e) => setError(e instanceof Error ? e.message : String(e)));
  }, []);

  if (!hasCommunity(brand.id)) return <Navigate to="/dashboard" replace />;

  if (error) return <main><p className="error">เข้า Chat โลกไม่ได้: {error}</p></main>;
  if (member === null) return <p style={{ padding: "3rem", color: "var(--c-text-muted)" }}>กำลังโหลด…</p>;
  if (!member) {
    return (
      <main>
        <div className="empty-state">
          <h2>Chat โลกสำหรับนักเรียนที่ซื้อคอร์สแล้ว</h2>
          <p>ถ้าซื้อแล้วแต่เข้าไม่ได้ ลองออกจากระบบแล้วล็อกอินด้วยอีเมลที่ใช้ตอนจ่ายเงิน</p>
          <Link to="/dashboard" className="btn btn-secondary">กลับหน้าคอร์สของฉัน</Link>
        </div>
      </main>
    );
  }
  return <Outlet />;
}

/** Counts time on the site for the leaderboard: one heartbeat a minute while
 *  the tab is visible. Mounted once in App for every signed-in user. */
export function ActiveTimer() {
  const { user } = useAuth();
  useEffect(() => {
    // AI-sthetics visitors never join the Dewviko leaderboard.
    if (!user || !hasCommunity(brand.id)) return;
    let member = false;
    callEnsureCommunityMember().then((m) => (member = m)).catch(() => {});
    const t = setInterval(() => {
      if (member && document.visibilityState === "visible") callRecordActiveMinute().catch(() => {});
    }, 60_000);
    return () => clearInterval(t);
  }, [user]);
  return null;
}

/** Round initial avatar with the Skool-style level number on its corner. */
export function MemberAvatar({ points, avatar }: { name: string; points?: number; avatar?: Avatar }) {
  return (
    <span className="cm-avatar cm-avatar--pixel" aria-hidden="true">
      <PixelAvatar avatar={avatar ?? DEFAULT_AVATAR} size={40} />
      {points !== undefined && <span className="cm-avatar__level">{levelForPoints(points)}</span>}
    </span>
  );
}
